module.exports = __webpack_public_path__ + "img/device_dr001.a6ad99b5.png";